<template>
  <div class="wrapper">
    <span class="label">{{ row.label }}</span>
    <div v-for="tag in row.tags" :key="tag.id">
      <DeviceTagIcon :color="getTagColor(tag.id)" />
    </div>
  </div>
</template>

<script>
import DeviceTagIcon from "@/module/component/DeviceTagIcon";
import { mapGetters } from "vuex";

export default {
  name: "TagFormatter",
  props: ["row"],
  components: {
    DeviceTagIcon,
  },
  methods: {
    getTagColor(tag) {
      let tagObj = this.getTagToColorMapping.filter((obj) => obj.id === tag);
      if (tagObj.length) return tagObj[0].color;
      else return "#000000";
    },
  },
  computed: {
    ...mapGetters("provider", ["getTagToColorMapping"]),
  },
};
</script>

<style scoped>
.label {
  padding-left: 10px;
  margin-right: 10px;
}

.wrapper {
  display: flex;
}
</style>
